import type { SessionResponse, SessionRoom } from '@dataroom/shared';

// The room portal is the BUYER surface. A buyer reaches a room through an access
// grant, surfaced on the session as `isMember` — so the portal operates on the
// rooms the signed-in actor is a member of, resolved at runtime from GET
// /auth/session (no longer a hardcoded demo room). The "Your data rooms" landing
// lists these, and each room is entered by its id in the path (/rooms/:roomId).
export function buyerRooms(session: SessionResponse | undefined): SessionRoom[] {
  return session?.rooms.filter((r) => r.isMember) ?? [];
}
